'use client';

import { CLIENT_PATHS } from '@/config/routes/client-paths';
import { TenantWebsite } from '@/layers/domain/value-objects/tenant/website/tenant-website.vo';
import { submitService } from '@/shared/application/services/submit.service';
import { CustomerFirstAccessDto } from '@/shared/components/forms/auth/customer/dtos/customer-first-access.dto';
import { CustomerForgotPasswordDto } from '@/shared/components/forms/auth/customer/dtos/customer-forgot-password.dto';
import { CustomerLoginDto } from '@/shared/components/forms/auth/customer/dtos/customer-login.dto';
import { CustomerPasswordRecoveryDto } from '@/shared/components/forms/auth/customer/dtos/customer-password-recovery.dto';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { DeleteCustomerDto } from '@/shared/components/forms/auth/customer/dtos/delete-customer.dto';

export class AuthCustomerService {
  public static login =
    (router: AppRouterInstance) => async (data: CustomerLoginDto) => {
      const websiteId = TenantWebsite.getIdFromPathname(location.pathname);
      await submitService(
        'CUSTOMER_LOGIN',
        data,
        () => {
          router.push(
            CLIENT_PATHS.CUSTOMER_DASHBOARD.replace(':websiteId', websiteId),
          );
        },
        {
          replace: [[':websiteId', websiteId]],
        },
      );
    };

  public static firstAccess =
    (router: AppRouterInstance) => async (data: CustomerFirstAccessDto) => {
      const websiteId = TenantWebsite.getIdFromPathname(location.pathname);
      await submitService(
        'CUSTOMER_FIRST_ACCESS',
        data,
        () => {
          router.push(
            CLIENT_PATHS.CUSTOMER_LOGIN.replace(':websiteId', websiteId),
          );
        },
        {
          replace: [[':websiteId', websiteId]],
        },
      );
    };

  public static forgotPassword =
    () => async (data: CustomerForgotPasswordDto) => {
      const websiteId = TenantWebsite.getIdFromPathname(location.pathname);
      await submitService(
        'CUSTOMER_FORGOT_PASSWORD',
        {
          ...data,
          url: `${location.origin}/website/${websiteId}/auth/customer/password-recovery`,
        },
        () => {},
        {
          replace: [[':websiteId', websiteId]],
        },
      );
    };

  public static passwordRecovery =
    (router: AppRouterInstance) =>
    async (data: CustomerPasswordRecoveryDto) => {
      const websiteId = TenantWebsite.getIdFromPathname(location.pathname);
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      await submitService(
        'CUSTOMER_PASSWORD_RECOVERY',
        { ...data, token },
        () => {
          router.push(
            CLIENT_PATHS.CUSTOMER_LOGIN.replace(':websiteId', websiteId),
          );
        },
        {
          replace: [[':websiteId', websiteId]],
        },
      );
    };

  public static delete = () => async (data: DeleteCustomerDto) => {
    const websiteId = TenantWebsite.getIdFromPathname(location.pathname);
    await submitService('DELETE_CUSTOMER', data, () => {}, {
      replace: [[':websiteId', websiteId]],
    });
  };
}
